import { Dispatch, GetState } from "common/types/redux";

import {
  doesCourseHaveExamQuestions,
  getCourseName
} from "seneca-common/features/course/state";
import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";
import {
  analyticsCategories,
  logGTMTrackingEvent,
  withLogAndSwallowError
} from "seneca-common/utils/senecaAnalytics";

import { individualAssignmentsStateConfig } from "../state/consts";

const {
  // @ts-ignore
  createActionTypes: { "CREATE_TEACHER-ASSIGNMENTS_SUCCESS": createAction }
} = makeCrudStateActionFactories(individualAssignmentsStateConfig);

export const analyticsLogCreateAssignment =
  withLogAndSwallowError(logCreateAssignment);

function logCreateAssignment(payload: any) {
  return (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    createAssignmentGTMTrackingEvent(state, payload);
  };
}

function createAssignmentGTMTrackingEvent(state: any, payload: any) {
  const { id, assignmentId, spec, assignees, numAssignees } = payload;
  const { courseId, questionIds } = spec;
  const courseName = courseId && getCourseName(state, courseId);

  const courseHasExamQuestions = doesCourseHaveExamQuestions(state, courseId);
  const numExamQuestions =
    courseHasExamQuestions && questionIds ? questionIds.length : null;

  logGTMTrackingEvent(
    {
      category: analyticsCategories.ASSIGNMENT,
      event: createAction,
      payload: {
        ...payload,
        numberOfAssignees: assignees?.length ?? numAssignees,
        courseId,
        courseName,
        assignmentId: id || assignmentId,
        numExamQuestions
      }
    },
    state
  );
}
